/**
 * Skip-to-Content Link — WCAG 2.1 accessibility requirement
 * Provides keyboard users a way to bypass navigation and jump to main content.
 */

export default function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[200] 
                 focus:rounded-xl focus:bg-[#7CFF6B] focus:px-5 focus:py-3 
                 focus:text-xs focus:font-black focus:text-[#0F1923] focus:shadow-lg"
    >
      Skip to main content
    </a>
  );
}
